







































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {InputSelect} from '@simpli/vue-input'
import {GithubOrganizationCollection} from '@/model/collection/GithubOrganizationCollection'
import CDActivityVolumeNav from '@/components/communityDevelopment/CDActivityVolumeNav.vue'
import CDActivityVolumeChart from '@/components/communityDevelopment/CDActivityVolumeChart.vue'
import {GithubRepositoryCollection} from '@/model/collection/GithubRepositoryCollection'
import {GithubRepositoryCommitCollection} from '@/model/collection/GithubRepositoryCommitCollection'

class CDSelectOption {
  $id: number
  $tag: string

  constructor(id: number, tag: string) {
    this.$id = id
    this.$tag = tag
  }
}

@Component({
  components: {
    InputSelect,
    CDActivityVolumeNav,
    CDActivityVolumeChart,
  },
})
export default class CDActivityVolumeSection extends Vue {
  @Prop({type: GithubOrganizationCollection, required: true})
  organizationCollection!: GithubOrganizationCollection

  @Prop({type: Object, default: () => ({})})
  commitsByOrganization!: Record<number, number>

  @Prop({type: GithubRepositoryCollection, required: true})
  repositoryCollection!: GithubRepositoryCollection

  @Prop({type: GithubRepositoryCommitCollection, required: true})
  repositoryCommitCollection!: GithubRepositoryCommitCollection

  @Prop({type: Number, default: null})
  selectedOrganizationId!: number | null

  showMobileFilter: boolean = false

  metricOptions = [new CDSelectOption(1, 'Commits')]

  periodOptions = [
    new CDSelectOption(7, 'Last 7 Days'),
    new CDSelectOption(30, 'Last 30 Days'),
  ]

  metricId: number = 1
  periodId: number = 7

  get selectedMetric(): CDSelectOption {
    return (
      this.metricOptions.find(o => o.$id === this.metricId) ||
      this.metricOptions[0]
    )
  }

  get selectedPeriod(): CDSelectOption {
    return (
      this.periodOptions.find(o => o.$id === this.periodId) ||
      this.periodOptions[0]
    )
  }

  visibleItemsIds: number[] = []

  mounted() {
    this.resetVisibleItems()
  }

  resetVisibleItems() {
    if (this.selectedOrganizationId !== null) {
      this.visibleItemsIds = (this.repositoryCollection?.items || []).map(
        it => it.$id
      )
    } else {
      this.visibleItemsIds = (this.organizationCollection.items || []).map(
        it => it.$id
      )
    }
  }

  toggleItem(id: number) {
    const set = new Set(this.visibleItemsIds)
    if (set.has(id)) set.delete(id)
    else set.add(id)
    this.visibleItemsIds = Array.from(set.values())
  }

  @Watch('organizationCollection.items', {deep: true})
  onCollectionChange() {
    if (!this.visibleItemsIds.length) {
      this.resetVisibleItems()
    }
  }

  @Watch('selectedOrganizationId')
  onSelectedOrganizationIdChange() {
    this.resetVisibleItems()
  }

  @Watch('repositoryCollection.items', {deep: true})
  onRepositoryCollectionChange() {
    if (this.selectedOrganizationId !== null) {
      this.resetVisibleItems()
    }
  }

  get hasAnyData(): boolean {
    return (
      (this.organizationCollection &&
        this.organizationCollection.items.length > 0) ||
      (this.repositoryCollection &&
        this.repositoryCollection.items.length > 0) ||
      (this.repositoryCommitCollection &&
        this.repositoryCommitCollection.items.length > 0)
    )
  }
}
